import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useGetBatchSkiptraceByListIdState = () =>
  useBatchSkiptraceStore(store => store.getByListId.state)
